module.exports = __webpack_public_path__ + "static/img/logo-hg.555fb9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-hg.svg
// module id = XO0b
// module chunks = 1